/**
 * The page delimiter for detecting the base pathname of an AEM Page. The part of the URL that comes before
 * and until this delimiter MUST NOT be changed by URL resolutions.
 *
 * @ignore
 */
export const AEM_PAGE_DELIMITER = '.html';

/**
 * Due to internal implementation details, some search parameters are forbidden from being used. The following
 * list includes the blocked search parameters
 */
export const BLACKLISTED_SEARCH_PARAMETERS = ['Path'];
